const invertedMessages = {
  'No pre-launch analysis has been run for this campaign yet.':
    'certs.prelaunch.empty.no.runs',
  'Start Analysis': 'certs.prelaunch.empty.start',
  'Starting Analysis…': 'certs.prelaunch.empty.starting',
  'A pre-launch analysis is already running for this campaign.':
    'certs.prelaunch.footer.conflict',
  Close: 'certs.prelaunch.close.button',
};

export default invertedMessages;
